/* @flow */
import _ from 'lodash'
// import moment from 'moment's

import {
  GET_ACTIVITIES,
  GET_ACTIVITIES_SUCCESS,
  GET_ACTIVITIES_FAILURE,
  SEARCH_ACTIVITY,
} from '../../configs/constants'
import InitialState from './initialState'

const initialState = new InitialState()

export default function activityReducer(state = initialState, action) {
  if (!(state instanceof InitialState)) return initialState.merge(state)

  switch (action.type) {
    case GET_ACTIVITIES:
      return state.set('isLoading', true)
    case GET_ACTIVITIES_SUCCESS:
      return state.set('all', action.activities)
                  .set('filtered', action.activities)
                  .set('isLoading', false)
    case GET_ACTIVITIES_FAILURE:
      return state.set('isLoading', false)
    // case SET_VIEW_SHOP:
    //   return state.set('current', action.activity)
    case SEARCH_ACTIVITY:
      const { shopIds, experience } = action.payload
      return state.set('filtered',
        _.filter(_.map(state.all, (item, key) => ({
          id: key,
          ...item,
        })
      ), (activity) => {
        return shopIds.indexOf(activity.shopId) >= 0
        //  &&
        //   _.filter(activity.availableList, (available) =>
        //     moment(available.startDate).isSameOrAfter(startDate, 'day') &&
        //     moment(available.endDate).isSameOrBefore(endDate, 'day')
        //   ).length > 0 &&
          && experience >= activity.minExperience
      }))
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/reducers/activity/index.js